export const GET_GRAPH = 'GET_GRAPH';

export const GET_TICKER = 'GET_TICKER';

export const GET_BALANCE = 'GET_BALANCE';

export const GET_ORDERS = 'GET_ORDERS';
export const SET_CUSTOM_FIELDS = 'SET_CUSTOM_FIELDS';


export const SET_TIMEFRAME_ACTIVE = 'TIMEFRAME_ACTIVE';

export const SET_TIME_FROM = 'SET_TIME_FROM';
export const SET_TIME_TO = 'SET_TIME_TO';
export const SET_SORT = 'SET_SORT';
export const SET_SORT2 = 'SET_SORT2';
export const SET_SORT3 = 'SET_SORT3';
export const SET_GROUP = 'SET_GROUP';
export const SET_PRICE_FROM = 'SET_PRICE_FROM';
export const SET_PRICE_TO = 'SET_PRICE_TO';
export const SET_PRICE_FROM_INIT = 'SET_PRICE_FROM_INIT';
export const SET_PRICE_TO_INIT = 'SET_PRICE_TO_INIT';
export const SET_SHOW_CANCELED_ORDERS = 'SET_SHOW_CANCELED_ORDERS';
export const SET_SHOW_BRUSH_FILTER = 'SET_SHOW_BRUSH_FILTER';


// Фильтры (интежеров)
export const SET_TXCNT_FROM = 'SET_TXCNT_FROM';
export const SET_TXCNT_TO = 'SET_TXCNT_TO';
export const SET_ITER_BUY_FROM = 'SET_ITER_BUY_FROM';
export const SET_ITER_BUY_TO = 'SET_ITER_BUY_TO';
export const SET_ITER_SELL_FROM = 'SET_ITER_SELL_FROM';
export const SET_ITER_SELL_TO = 'SET_ITER_SELL_TO';
export const SET_TARG_IDX_FROM = 'SET_TARG_IDX_FROM';
export const SET_TARG_IDX_TO = 'SET_TARG_IDX_TO';
export const SET_ORDER_ID_FROM = 'SET_ORDER_ID_FROM';
export const SET_ORDER_ID_TO = 'SET_ORDER_ID_TO';
export const SET_FILTER_ORDER_ID_PAIRED_FROM = 'SET_FILTER_ORDER_ID_PAIRED_FROM';
export const SET_FILTER_ORDER_ID_PAIRED_TO = 'SET_FILTER_ORDER_ID_PAIRED_TO';

// Фильтры (флоты)
export const SET_AMOUNT_FOR_OPER_FROM = 'SET_AMOUNT_FOR_OPER_FROM';
export const SET_AMOUNT_FOR_OPER_TO = 'SET_AMOUNT_FOR_OPER_TO';
export const SET_ORDER_AMOUNT_FOR_OPER_EXEC_FROM = 'SET_ORDER_AMOUNT_FOR_OPER_EXEC_FROM';
export const SET_ORDER_AMOUNT_FOR_OPER_EXEC_TO = 'SET_ORDER_AMOUNT_FOR_OPER_EXEC_TO';
export const SET_ORDER_PRICE_FROM = 'SET_ORDER_PRICE_FROM';
export const SET_ORDER_PRICE_TO = 'SET_ORDER_PRICE_TO';
export const SET_ORDER_ORIG_AMOUNT_FROM = 'SET_ORDER_ORIG_AMOUNT_FROM';
export const SET_ORDER_ORIG_AMOUNT_TO = 'SET_ORDER_ORIG_AMOUNT_TO';
export const SET_ORDER_AMOUNT_FROM = 'SET_ORDER_AMOUNT_FROM';
export const SET_ORDER_AMOUNT_TO = 'SET_ORDER_AMOUNT_TO';
export const SET_ORDER_EXEX_FROM = 'SET_ORDER_EXEX_FROM';
export const SET_ORDER_EXEX_TO = 'SET_ORDER_EXEX_TO';
export const SET_FEE_RESULT_FROM = 'SET_fee_RESULT_FROM';
export const SET_FEE_RESULT_TO = 'SET_fee_RESULT_TO';
export const SET_ORDER_REMAINS_FROM = 'SET_ORDER_REMAINS_FROM';
export const SET_ORDER_REMAINS_TO = 'SET_ORDER_REMAINS_TO';

// Фильтры (селекты)
export const SET_FILTER_SIDE = 'SET_FILTER_SIDE';
export const SET_FILTER_STATUS = 'SET_FILTER_STATUS';
export const SET_FILTER_TYPE = 'SET_FILTER_TYPE';
export const SET_FILTER_ORDER_ALG = 'SET_FILTER_ORDER_ALG';
export const SET_FILTER_IS_ROBOT_ORDER = 'SET_FILTER_IS_ROBOT_ORDER';
export const SET_FILTER_CYCLE_END = 'SET_FILTER_CYCLE_END';
export const SET_FILTER_CYCLE_STAGE = 'SET_FILTER_CYCLE_STAGE';
export const SET_FILTER_BASE_CURR = 'SET_FILTER_BASE_CURR';

// Фильтры (даты)
export const SET_FILTER_SDTIME_FROM = 'SET_FILTER_SDTIME_FROM';
export const SET_FILTER_SDTIME_TO = 'SET_FILTER_SDTIME_TO';
export const SET_FILTER_FDTIME_FROM = 'SET_FILTER_FDTIME_FROM';
export const SET_FILTER_FDTIME_TO = 'SET_FILTER_FDTIME_TO';

// Настройки и данные графика профита
export const GET_PROFIT = 'GET_PROFIT';

export const GET_PROFIT_DONE = 'GET_PROFIT_DONE';
export const SET_PROFIT_TIME_FROM_MAX = 'SET_PROFIT_TIME_FROM_MAX';
export const SET_PROFIT_TIME_TO_MAX = 'SET_PROFIT_TIME_TO_MAX';
export const SET_PROFIT_TIME_FROM = 'SET_PROFIT_TIME_FROM';
export const SET_PROFIT_TIME_TO = 'SET_PROFIT_TIME_TO';